import { render } from "./ActivityVideoPlayer.vue?vue&type=template&id=0fafcbe0"
import script from "./ActivityVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./ActivityVideoPlayer.vue?vue&type=script&lang=ts"

import "./ActivityVideoPlayer.vue?vue&type=style&index=0&id=0fafcbe0&lang=scss"
script.render = render

export default script